import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=fa27b6c2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=fa27b6c2&prod&scoped=true&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=fa27b6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa27b6c2",
  null
  
)

export default component.exports